import React from 'react';
import PropTypes from 'prop-types';
import Range from './range/range';
import * as constants from './range/constants';

class DualRange extends React.Component {
  constructor(props) {
    super(props);

    this.defaultValues = {
      [constants.KEY_LEFT]: null,
      [constants.KEY_RIGHT]: null,
    };

    this.state = {
      selected: this.props.selected,
    };
  }

  static deriveStateFromProps(nextProps) {
    return {
      selected: nextProps.selected,
    };
  }

  getPropsForRange(key) {
    const values = this.props.values;
    const selected = this.state.selected;

    let newProps = {
      ...this.props,
      values: {
        min_value: values.min_value,
        max_value: values.max_value,
        values: values.values[key],
      },
    };

    if (selected) {
      newProps = { ...newProps, selected: selected[key] };
    }

    return newProps;
  }

  static selectedIsNull(selected) {
    return Object.keys(selected).filter(index => selected[index]).length === 0;
  }

  onChange(key, evt) {
    // The API requires us to send in both 'from' and 'to', null values are okay however.
    // This merges the nullified values with the selected and finally the changed value
    let newSelected = {
      ...this.defaultValues,
      ...this.state.selected,
      [key]: evt,
    };

    // If both 'from' and 'to' is null we will make the entire setting null(aka, clear it)
    if (DualRange.selectedIsNull(newSelected)) {
      newSelected = null;
    }

    this.setState({
      selected: newSelected,
    });

    this.props.onChange({
      value: newSelected,
    });
  }

  render() {
    return (
      <div>
        <Range
          {...this.getPropsForRange(constants.KEY_LEFT)}
          onChange={evt => this.onChange(constants.KEY_LEFT, evt)}
        />
        <Range
          {...this.getPropsForRange(constants.KEY_RIGHT)}
          onChange={evt => this.onChange(constants.KEY_RIGHT, evt)}
        />
      </div>
    );
  }
}

DualRange.propTypes = {
  onChange: PropTypes.func.isRequired,
  values: PropTypes.shape({
    max_matching_products: PropTypes.number,
    max_values: PropTypes.number,
    min_values: PropTypes.number,
    values: PropTypes.shape({
      from: PropTypes.arrayOf(
        PropTypes.shape({
          from: PropTypes.number,
          to: PropTypes.number,
          products: PropTypes.number,
        })
      ),
      to: PropTypes.arrayOf(
        PropTypes.shape({
          from: PropTypes.number,
          to: PropTypes.number,
          products: PropTypes.number,
        })
      ),
    }),
  }).isRequired,
  selected: PropTypes.shape({
    from: PropTypes.shape({
      from: PropTypes.number,
      to: PropTypes.number,
    }),
    to: PropTypes.shape({
      from: PropTypes.number,
      to: PropTypes.number,
    }),
  }),
  layout: PropTypes.oneOf(['vertical', 'horizontal']),
};

DualRange.defaultProps = {
  selected: null,
  layout: 'vertical',
};

export default DualRange;
